import type { DocsOpenDocumentRequest } from '@/features/docs/utils/docsOpenRequest';

const DOCS_OPEN_REQUEST_QUERY_KEYS = {
  nodeId: 'docsNodeId',
  projectId: 'docsProjectId',
  candidateNodeIds: 'docsCandidateNodeIds',
  title: 'docsTitle',
  type: 'docsType',
  parentId: 'docsParentId',
} as const;

export const getDocsOpenRequestFromLocation = (): DocsOpenDocumentRequest | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const params = new URLSearchParams(window.location.search);
    const nodeId = params.get(DOCS_OPEN_REQUEST_QUERY_KEYS.nodeId);
    if (!nodeId) {
      return null;
    }

    const candidateNodeIds = (params.get(DOCS_OPEN_REQUEST_QUERY_KEYS.candidateNodeIds) || '')
      .split(',')
      .map((value) => value.trim())
      .filter(Boolean);

    return {
      nodeId,
      projectId: params.get(DOCS_OPEN_REQUEST_QUERY_KEYS.projectId) || undefined,
      candidateNodeIds: candidateNodeIds.length > 0 ? candidateNodeIds : undefined,
      title: params.get(DOCS_OPEN_REQUEST_QUERY_KEYS.title) || undefined,
      type: (params.get(DOCS_OPEN_REQUEST_QUERY_KEYS.type) as DocsOpenDocumentRequest['type'] | null) || undefined,
      parentId: params.get(DOCS_OPEN_REQUEST_QUERY_KEYS.parentId) || undefined,
      requestedAt: Date.now(),
    };
  } catch {
    return null;
  }
};
